import { SET_CONFERENCE } from '../actions/type'

const initialState = {
    conferencesList: [],
    conference_jwt: '',
    statusData: ''
}

const conferences = (state = initialState, action) => {
    switch (action.type) {
        case SET_CONFERENCE: {
            const payload = action.payload;
            return { ...state, ...payload };
        }
        default:
            return state
    }
}

export default conferences